/**
 * Form Fields enum
 */
export const FormFields = {
  FirstName: 'firstName',
  LastName: 'lastName',
  Email: 'email',
  Address: 'dealershipAddress',
  State: 'dealershipState',
  ZipCode: 'dealershipZipCode',
  City: 'dealershipCity',
  PhoneNumber: 'phoneNumber',
  DealershipName: 'dealershipName',
}
